import { classNames, React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import FocusLock from 'react-focus-lock';

const cx = classNames;

export const PopoverBody = ({ children, size, className }) => {
  const classes = cx('c-popover__body', className, {
    [`c-popover__body--size-${size}`]: !!size,
  });
  return (
    <FocusLock autoFocus={false} className={classes}>
      {children}
    </FocusLock>
  );
};

PopoverBody.propTypes = {
  /**
   * Popover body size
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
  children: PropTypes.any,
};

PopoverBody.defaultProps = {
  size: 'small',
  className: '',
};
